import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { AsidePollProps } from './AsidePollModal.types';

export const openAsidePollModal = ({ onClose, ...data }: AsidePollProps) =>
    openPopupHelper({ popupName: popupNames.ASIDE_POLL, data, onClose });
